import {IServiceConfig} from '../../Models/Client'
import {LogLevel} from '../../Models/Client/Enums'

const DebugConfig: IServiceConfig = {
  //ToprAuthUrl: 'https://localhost:5001/', //ngrok niet nodig, https lijkt niet te werken
  ToprAuthUrl: 'http://localhost:57130/',
  //BaseUrl: 'https://f5a8-90-145-223-18.ngrok-free.app/',
  //BaseUrl: 'https://core.topr.services/',
  BaseUrl: 'https://localhost:44340/',
  //CmsUrl: 'http://localhost:51526',
  //CmsUrl: 'https://6af6-90-145-223-18.ngrok-free.app',
  CmsUrl: 'https://cms.toprwallet.nl',
  ClientId: '797e1a1a-70bf-4ca9-9320-5e30ae98704c', //toprclientid:6 toprConsumerapp
  Secret: '',
  ShowLogging: false,
  LogLevel: LogLevel.Info,
}

export default DebugConfig
